"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrans = void 0;
const React = require("react");
const hoistNonReactStatic = require("hoist-non-react-statics");
const context_1 = require("./context");
function useTrans(WrapperComponent) {
    class WithTransPageComponent extends React.Component {
        render() {
            const { gettext, localeObj } = this.context;
            const _a = this.props, { forwardedRef } = _a, props = __rest(_a, ["forwardedRef"]);
            return (React.createElement(WrapperComponent, Object.assign({ ref: forwardedRef }, props, { gettext: gettext, localeObj: localeObj })));
        }
    }
    WithTransPageComponent.contextType = context_1.I18NContext;
    const WithRefComponent = React.forwardRef((props, ref) => React.createElement(WithTransPageComponent, Object.assign({}, props, { forwardedRef: ref })));
    return hoistNonReactStatic(WithRefComponent, WrapperComponent);
}
exports.useTrans = useTrans;
//# sourceMappingURL=useTrans.js.map